export default __webpack_public_path__ + "static/media/Status-positive.34f1b80f.svg";